// 碳积分提现分红
export default {
  routes: [
    {
      path: '/worry-free-selling',
      name: 'worryFreeSelling',
      meta: {
        title: '转转回收',
        pageId: 'V8849',
        isAutoPV: false
      },
      component: () =>
        import(/* webpackChunkName: "worryFreeSelling" */ '../views/worryFreeSelling/index.vue')
    },
    {
      path: '/recycle',
      name: 'recycle',
      meta: {
        title: '转转回收',
        pageId: 'J3353',
        isAutoPV: false
      },
      component: () => import(/* webpackChunkName: "recycle" */ '../views/recycle/index.vue')
    }
  ]
}
